module.exports = __webpack_public_path__ + "img/visa.ec957c44.svg";